import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './store/GlobalStore';
import { Route, Routes, Navigate } from 'react-router-dom';
import ScrollToTop from './utils/ScrollToTop';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import PrivateRoute from './utils/PrivateRoute';
import './App.scss';
import Login from './pages/Login';
import Profil from './pages/account/Profil';
import Info from './pages/account/Info';
import Notifications from './pages/account/Notifications';
import Reservation from './pages/Reservation';
import AllReservations from './pages/AllReservations';
import Activities from './pages/Activities';
import BookingDetailPage from './pages/BookingDetailPage';
import Favorites from './pages/Favorites';
import CreateIncident from './pages/CreateIncident';
import ReserveAnimation from './pages/ReserveAnimation';
import FollowIncidents from './pages/FollowIncidents';
import IncidentDetailPage from './pages/IncidentDetailPage';
import MyAnimations from './pages/MyAnimations';
import Animations from './pages/Animations';
import BookingOptions from './pages/BookingOptions'
import FicheHebergement from './pages/FicheHebergement'
// Import the bot App component
import BotApp from './bot/src/App';
import CheckIn from './pages/CheckIn';
import AllCheckIn from './pages/AllCheckIn';
import AllCheckOut from './pages/AllCheckOut';
import CheckOut from './pages/CheckOut';
import AnimationDetailPage from './pages/AnimationDetailPage';
import { setIsUsedOnBorne } from './store/slices/authSlice';
import GDPRBanner from './components/gdpr/GDPRBanner';
import RouteChangeSync from './components/layout/RouteChangeSync';

const App = () => {
  const dispatch = useDispatch();
  const isUsedOnBorne = useSelector((state: RootState) => state.Auth.isUsedOnBorne);
  const mode = useSelector((state: RootState) => state.Bot.mode);
  useEffect(() => {
    // Logique pour déterminer si l'utilisateur est sur une borne tactile
    let isBorne : boolean = false;
    /*@ts-ignore*/
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    //Tactile + 1080x1920
    if(isTouchDevice) {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      isBorne = screenWidth >= 1080 || screenHeight >= 1920;
    }


    //const isBorne = window.matchMedia("(min-height: 1900px)").matches;
    console.log('isBorne', isBorne);
    dispatch(setIsUsedOnBorne(isBorne));
  }, [dispatch]);



  return (
    <div className={`App ${!isUsedOnBorne ? (mode === 2 ? 'botTextMode' : 'botSpeechMode') : ''}`}>
      <ScrollToTop />
      {!isUsedOnBorne && <RouteChangeSync />}
      {!isUsedOnBorne && <Header />}

      <Routes>
        {isUsedOnBorne ? (
          <Route path='/' element={<BotApp />} />
        ) : (
          <>
            <Route path='/login' element={<Login />} />
            <Route path='/mon-compte' element={<PrivateRoute Component={<Profil />} />} />
            <Route path='/mon-informations' element={<PrivateRoute Component={<Info />} />} />
            <Route path='/notifications' element={<PrivateRoute Component={<Notifications />} />} />
            <Route path='/create-incidient' element={<PrivateRoute Component={<CreateIncident />} />} />
            <Route path='/follow-incidents' element={<PrivateRoute Component={<FollowIncidents />} />} />
            <Route path='/incident/:id' element={<PrivateRoute Component={<IncidentDetailPage />} />} />
            <Route path='/all-reservations' element={<PrivateRoute Component={<AllReservations />} />} />
            <Route path='/reservation/:id' element={<PrivateRoute Component={<Reservation />} />} />
            <Route path='/booking/:id' element={<PrivateRoute Component={<BookingDetailPage />} />} />
            <Route path='/check-in' element={<PrivateRoute Component={<AllCheckIn />} />} />
            <Route path='/check-out' element={<PrivateRoute Component={<AllCheckOut />} />} />
            <Route path='/check-in/:ressource/:asterioId/:id' element={<PrivateRoute Component={<CheckIn />} />} />
            <Route path='/check-out/:ressource/:asterioId/:id' element={<PrivateRoute Component={<CheckOut />} />} />
            <Route path="/booking-options/:asterioId" element={<PrivateRoute Component={<BookingOptions />} />} />
            <Route path='/activities' element={<PrivateRoute Component={<Activities />} />} />
            <Route path='/animations' element={<PrivateRoute Component={<Animations />} />} />
            <Route path='/reserve-animation/:id' element={<ReserveAnimation />} />
            <Route path='/my-animations' element={<PrivateRoute Component={<MyAnimations />} />} />
            <Route path='/animation-details/:id' element={<PrivateRoute Component={<AnimationDetailPage />} />} />
            <Route path='/favorites' element={<PrivateRoute Component={<Favorites />} />} />
            <Route path='/fiche-hebergement/:bookingId/:ressourceTypeCode' element={<PrivateRoute Component={<FicheHebergement />} />} />
            <Route path='/' element={<BotApp />} />
            <Route path='*' element={<Navigate to='/' />} />
          </>
        )}
      </Routes>
      {!isUsedOnBorne && <GDPRBanner />}


      {/* <Footer /> */}
    </div>
  );
};

export default App;
